var __TEMP__ = require('./_assignValue.js');var assignValue = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseZipObject.js');var baseZipObject = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = zipObject;
